import _ from 'lodash';

type AnyStr = string | number | null | undefined


/**
 * todo implement sisPad method that respects key-field logic. (alphanumeric -> use ' ' right padding, numeric use '0' and left padding)
 * @param inputString input string
 * @param width wanted length of resulting string
 * @param [padString] default is '0', inputString gets filled with this from left.
 *            it is also possible to fill with multi character strings i.e. "&nbsp;" (seen as one char)
 * @param [padRight] default false (pad left side), if true then padString is padded on right side.
 * @returns {string}
 */
export function padStr(inputString: AnyStr, width: number | string, padString?: string, padRight?: boolean) {
	padString = padString || '0';
	width = parseInt(width as string);
	if (!inputString && (inputString === undefined || inputString === null || isNaN(inputString as number))) inputString = '';
	inputString = inputString + '';
	if (inputString.length >= width) return inputString;
	let ret = '';
	if (padRight) ret += inputString;
	ret += new Array(width - inputString.length + 1).join(padString);
	if (!padRight) ret += inputString;
	return ret;
}

/**
 *
 * @param {Number | String | null | undefined} dest string to apply val to
 * @param {Number | String | null | undefined} val always use val.trim() to ensure minimal modification
 * @param {Number} startIndex
 * @param {Number} length
 * @param {{}} [options]
 * @param {String} [options.nullValueRepresentation] if the result is '' it will be replaced with this value
 * @returns {string} if the trimmed result is Empty, an empty String is returned instead.
 */
export function setFixedStringAt(dest: AnyStr, val: AnyStr, startIndex: number, length: number, options?: { nullValueRepresentation?: string | null }) {
	let nvl = (options && typeof options.nullValueRepresentation === 'string') ? options.nullValueRepresentation : ''
	let padChar = ' '
	if (!dest && dest !== 0) dest = ''
	if (!val && val !== 0) val = nvl
	let d = dest + ''
	let beforeVal = d.substr(0, startIndex)
	beforeVal = padStr(beforeVal, startIndex, padChar, true)
	let newVal = (val + '').substr(0, length)
	let afterVal = ''
	let afterValStartIndex = startIndex + length
	if (afterValStartIndex < d.length) {
		//has string part after val -> pad new val and add afterVal
		newVal = padStr(newVal, length, padChar, true)
		afterVal = d.substr(afterValStartIndex, d.length)
	}
	let ret = beforeVal + newVal + afterVal
	if (!ret.trim()) return nvl
	return ret
}

/**
 * Can be used as getter for values that were set by setFixedStringAt.
 * @param val {String | Number | null | undefined} if not string or number, null is returned
 * @param startIndex
 * @param length
 * @returns {String | Number} if val is a number the method returns also a number.
 */
export function substrTypeaware(val: string | number | null | undefined, startIndex: number, length: number) {
	let valType = typeof val;
	if (valType !== 'number' && valType !== 'string') return null;
	if (typeof val === 'number' && isNaN(val)) return NaN;
	val = (val + '').substr(startIndex, length);
	if (valType === 'number') val = parseFloat(val);
	else if (valType === 'string') val = val.trim();
	return val;
}


/**
 * When text contains characters: upshift.
 * When text contains only Numbers: fill with leading zeros.
 * @param {String | Number} text
 * @param {Number} length
 *
 * @returns {String} null on error, applied key field value or blank(" ") for nothing.
 */
export function applySisKeyFieldRuleset(text: AnyStr, length: number) {
	if (typeof text === "number" && !isNaN(text)) text = "" + text; // number allowed
	if (typeof text !== "string") return null;
	text = text.trim();
	if (text === "") return " ";
	if (/^[0-9]*$/g.test(text)) {  //numbers only
		text = padStr(text, length, "0", false);
	} else if (/^[0-9A-Za-z\.\+\-:_#/%]*$/g.test(text)) { //mixed
		text = text.toUpperCase();
	} else {
		text = null;
	}

	return text && text.substr(0, length);
}

export function stringifyObjectPath(obj: any) {
	if (!_.isPlainObject(obj)) return obj; //#3
	var separator = '.';
	var toReturn: { [key in string]: any } = {};
	for (var i in obj) {
		if (!obj.hasOwnProperty(i)) continue;

		if (_.isPlainObject(obj[i]) && _.size(obj[i]) > 0) { // #3 #4.1
			var flatObject = stringifyObjectPath(obj[i]);
			for (var x in flatObject) {
				if (!flatObject.hasOwnProperty(x)) continue;

				toReturn[i + separator + x] = flatObject[x];
			}
		} else {
			toReturn[i] = obj[i];
		}
	}
	return toReturn;
}

export function objectifyStringPath(obj: any) {
	if (!_.isPlainObject(obj) || _.size(obj) === 0) return obj; // #3 #4.1
	var separator = '.';
	var result = {};
	_.each(obj, function (value, rootKey) {
		var path = rootKey.split(separator);
		var childObj = {};
		var prevObj: { [key in string]: any } = childObj;
		for (var i = 0; i < path.length; i++) {
			var childVal;
			if (i === path.length - 1) { //last
				if (_.isPlainObject(value)) value = objectifyStringPath(value);
				childVal = value;
			} else {
				childVal = {};
			}
			prevObj[path[i]] = childVal;
			prevObj = childVal;
		}
		result = _.merge(result, childObj);
	});
	return result;
}

export function stripHTML(stringContainingHTML?: string) {
	if (!stringContainingHTML) return ''
	let tmp = document.createElement("DIV");
	tmp.innerHTML = stringContainingHTML;
	return (tmp.textContent || tmp.innerText || "").trim();
}